<ion-grid>
  <!-- Header with Stats -->
  <ion-row>
    <ion-col>
      <ion-card>
        <ion-card-header>
          <ion-card-title>Knowledge Gap Recommendations</ion-card-title>
          <ion-card-subtitle
            >AI-detected opportunities to improve your knowledge
            base</ion-card-subtitle
          >
        </ion-card-header>
      </ion-card>
    </ion-col>
  </ion-row>

  <!-- Filters and Search -->
  <ion-row>
    <ion-col>
      <div class="filter-controls">
        <ion-searchbar
          mode="ios"
          placeholder="Search recommendations..."
          showCancelButton="never"
          class="rounded-search-bar"
          [(ngModel)]="searchText"
          (ionInput)="getRecommendations()"
        >
        </ion-searchbar>

        <app-filter-button
          [options]="filterOptions"
          (didChange)="filtersDidChange($event)"
        >
        </app-filter-button>
      </div>
    </ion-col>
  </ion-row>

  <!-- Recommendations List -->
  <ion-row>
    <ion-col>
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <ion-spinner></ion-spinner>
        <p>Loading recommendations...</p>
      </div>

      <!-- Recommendations List -->
      <div
        *ngIf="
          !isLoading && recommendationsDataSource.lastResponse?.data?.length > 0
        "
      >
        <ion-card
          *ngFor="
            let recommendation of recommendationsDataSource.lastResponse.data
          "
          class="recommendation-card"
        >
          <ion-card-content>
            <div class="category-header">
              <h2>{{ recommendation.category }}</h2>
              <ion-chip
                [color]="
                  getRecommendationTypeColor(recommendation.recommendationType)
                "
                class="type-chip"
              >
                <ion-icon
                  [name]="
                    getRecommendationTypeIcon(recommendation.recommendationType)
                  "
                  slot="start"
                ></ion-icon>
                {{
                  recommendation.recommendationType === "create"
                    ? "Create"
                    : "Update"
                }}
              </ion-chip>
            </div>

            <p class="synopsis">{{ getSynopsis(recommendation) }}</p>

            <!-- Conversation links -->
            <div
              class="conversation-links"
              *ngIf="getTopicsFromInsights(recommendation).length > 0"
            >
              <h4>Related Conversations:</h4>
              <div>
                <a
                  *ngFor="
                    let topic of getTopicsFromInsights(recommendation).slice(
                      0,
                      3
                    )
                  "
                  [href]="getConversationUrlForTopic(topic)"
                  class="conversation-link"
                  target="_blank"
                  rel="noopener"
                >
                  {{ topic.conversation?.title || topic.topicTitle }} →
                </a>
                <a
                  *ngIf="getTopicsFromInsights(recommendation).length > 3"
                  class="conversation-link"
                  (click)="
                    viewConversationsForRecommendation(recommendation, $event)
                  "
                  href="#"
                >
                  +{{ getTopicsFromInsights(recommendation).length - 3 }} more
                  conversations →
                </a>
              </div>
            </div>

            <div class="action-buttons">
              <ion-button
                fill="solid"
                color="primary"
                size="default"
                (click)="createArticleFromRecommendation(recommendation)"
              >
                Generate article
              </ion-button>
              <ion-button
                fill="clear"
                size="default"
                color="medium"
                (click)="toggleIgnoreRecommendation(recommendation)"
              >
                Dismiss
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>
      </div>

      <!-- Empty State -->
      <div
        *ngIf="
          !isLoading &&
          (!recommendationsDataSource.lastResponse ||
            recommendationsDataSource.lastResponse.data.length === 0)
        "
        class="empty-state"
      >
        <ion-card>
          <ion-card-content class="ion-text-center">
            <ion-icon
              name="bulb-outline"
              size="large"
              color="medium"
            ></ion-icon>
            <h3>No Knowledge Gap Recommendations</h3>
            <p>No recommendations found. This could mean:</p>
            <ul>
              <li>Your knowledge base is comprehensive</li>
              <li>No patterns have been detected yet</li>
              <li>Try adjusting your filters</li>
            </ul>
          </ion-card-content>
        </ion-card>
      </div>

      <!-- Pagination Controls -->
      <div
        *ngIf="
          !isLoading && recommendationsDataSource.lastResponse?.data?.length > 0
        "
        class="pagination-container"
      >
        <ion-button
          fill="clear"
          [disabled]="
            recommendationsDataSource.lastResponse?.cursors?.hasPrevious !==
            true
          "
          (click)="previousPage()"
        >
          <ion-icon name="chevron-back" slot="start"></ion-icon>
          Previous
        </ion-button>
        <span class="pagination-info">
          {{ recommendationsDataSource.lastResponse?.data?.length || 0 }}
          recommendations
          <span *ngIf="recommendationsDataSource.lastResponse?.totalCount">
            of {{ recommendationsDataSource.lastResponse.totalCount }}
          </span>
        </span>
        <ion-button
          fill="clear"
          [disabled]="
            recommendationsDataSource.lastResponse?.cursors?.hasNext !== true
          "
          (click)="nextPage()"
        >
          Next
          <ion-icon name="chevron-forward" slot="end"></ion-icon>
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
